module.exports = __webpack_public_path__ + "img/tyjl-back.19c65420.png";